import { render } from "./TargetStatistics.vue?vue&type=template&id=60ec45dd&scoped=true"
import script from "./TargetStatistics.vue?vue&type=script&lang=js"
export * from "./TargetStatistics.vue?vue&type=script&lang=js"

import "./TargetStatistics.vue?vue&type=style&index=0&id=60ec45dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ec45dd"]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QTable,QBtn,QTooltip});
